const SessionPriceResource = function ($resource, ApiRequestParams, AppConfig) {
    return $resource(
        AppConfig.apiBaseUrl + 'tickets/sessionprice',
        ApiRequestParams.defaults(),
        {
            query: {
                method: 'GET'
            }
        }
    );
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = SessionPriceResource;
}
